import serviceApi from 'services/api';
import auth from 'services/auth';

const api = process.env.REACT_APP_ENVIRONMENT === 'local' ? auth : serviceApi;

/* The VisitorProps type represents the properties of a Visitor, including its UUID, phoneNumber, email, firstName, lastName, reason, 
tag, company, buildingUuid and createdAt. */
export type VisitorProps = {
  uuid?: string;
  phoneNumber?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  reason?: string;
  tag?: string;
  company?: string;
  buildingUuid?: string;
  createdAt?: any;
};

/* The function `findAllVisitors` is an asynchronous function that makes a GET request to the `/apiv1/admin/visitors` endpoint and returns 
all the visitors data from the response. */
const findAllVisitors = async () => {
  const response = await api.get<VisitorProps[]>('/apiv1/admin/visitors');
  return response?.data;
};

/* The function `findVisitorById` retrieves a visitor object from an API based on the provided UUID. */
const findVisitorById = async (uuid: string | undefined) => {
  const response = await api.get<VisitorProps>(`/apiv1/admin/visitor/${uuid}`);
  return response?.data;
};

/* The function creates a new visitor by making a POST request to the `/apiv1/admin/visitor` endpoint with the provided visitor data. */
const createVisitor = async (newVisitor: VisitorProps) => {
  const response = await api.post<VisitorProps>('/apiv1/admin/visitor', newVisitor);
  return response?.data;
};

/* The function `updateVisitor` is an asynchronous function that updates a visitor using a PUT request to an API endpoint. */
const updateVisitor = async (uuid: string | undefined, updatedVisitor: VisitorProps) => {
  const response = await api.put<VisitorProps>(`/apiv1/admin/visitor/${uuid}`, updatedVisitor);
  return response?.data;
};

/* The function `deleteVisitor` is an asynchronous function that deletes a visitor by its UUID using an API call. */
const deleteVisitor = async (uuid: string | undefined) => {
  const response = await api.delete<VisitorProps>(`/apiv1/admin/visitor/${uuid}`);
  return response?.data;
};

const VisitorService = {
  findAllVisitors,
  createVisitor,
  findVisitorById,
  updateVisitor,
  deleteVisitor
};

export default VisitorService;
